export { default } from './part-why-replace';
